import { createFileRoute } from "@tanstack/react-router";
import PartsCatalogContentPage from "@/pages/PartsCatalogContentPage";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/parts-catalog/page/$slug")({
  head: () => pageHead({ title: 'Rex & Sons RVs', description: 'Rex & Sons RVs — family-owned RV dealer in Castle Hayne, NC since 1997. Sales, service, parts and rentals.', path: '/parts-catalog/page/:slug' }),
  component: PartsCatalogContentPage,
});
